import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { defineMessages } from 'react-intl-next';
export var ViewFormMessage = /*#__PURE__*/function (ViewFormMessage) {
  ViewFormMessage["HiddenSection"] = "HiddenSection";
  return ViewFormMessage;
}({});
export var IntlViewFormMessages = defineMessages(_defineProperty({}, ViewFormMessage.HiddenSection, {
  id: 'form-system.viewForm.HiddenSection',
  defaultMessage: 'Hidden section - Conditions apply'
}));